/**
 * One subscription to "settings were written" (`settings` frames).
 *
 * The server says `settings` once for each settings write the record holds,
 * naming the namespace and nothing of what changed
 * (`WorkbenchService._on_event`). `App.tsx` hands every frame here, and a
 * component showing a setting reads it again when its own namespace is named
 * (`ModelReadiness`). A component on the page that writes settings itself says
 * so here as soon as it is answered (`ModelSourceSettings`), so the forms beside
 * it are not a stream frame behind. `resync` is the stream coming back after a gap: a write
 * may have gone unheard, so every reader reads once more. Same shape as
 * `workFeed`.
 */

type SettingsTick = { namespace: string | null };
type Listener = (tick: SettingsTick) => void;
const listeners = new Set<Listener>();

export const settingsFeed = {
  /** A `settings` frame off the stream. */
  publish(tick: SettingsTick): void {
    for (const listener of [...listeners]) listener(tick);
  },
  /** Anything may have been written while the stream was down. */
  resync(): void {
    settingsFeed.publish({ namespace: null });
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
